"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortById = void 0;
function sortById(items) {
    return [...items].sort((a, b) => a.id - b.id);
}
exports.sortById = sortById;
